import { ThemeType } from "./baseTheme";
import { createMuiTheme } from "@material-ui/core/styles";

// 'MSA' palette of colors
const primaryColor = "#0B3B60"; // Dark Blue
const secondaryColor = "#FFFFFF"; // Light Blue
const headerTopBorderColor = "#000000DE"; // Dark blue
const headerBottomBorderColor = "#FFF";
const mainBackgroundColor = "#E5E5E5"; // Very light gray
const listSelectionColor = "#F5F5F5"; // Not so light gray
const footerColor = "#000"; // Black
const footerTextColor = "#FFF";
const footerTopBorderColor = "#c9c9c9"; // Very light gray
const searchButtonBorderRadius = "4px";
const listItemHoverColor = "#FAFAFA";
// Links for header
const contactUsLink = "https://msainsurance.com/contact";
const logoLink = "https://msainsurance.com/";
// Links for Footer
const companyInformation = "https://msainsurance.com/newsroom/our-companies";
const termsAndConditions =
  "https://msainsurance.com/sites/default/files/Terms_and_Conditions.pdf";
// Contact number
const contactNumber = "877-425-2467";
// Texts
const footerText = `©2010 - ${new Date().getFullYear()} Main Street America Insurance. All rights reserved.`;
const title = "Find a Repair Shop";
const description =
  "Our Value in Partnership Program takes the stress out of choosing a repair shop and offers a lifetime workmanship guarantee. \nSearch by city, shop name or ZIP code and connect with a trusted, customer-friendly repair shop near you.";
const noShopsFoundMessage =
  "\nTry searching for another location.\n\nFor immediate repair shop assistance contact claims at " +
  `${contactNumber}`;

export const msaTheme = createMuiTheme({
  palette: {
    primary: {
      main: `${secondaryColor}`,
    },
  },
  custom: {
    colors: {
      primaryColor: `${primaryColor}`,
      secondaryColor: `${secondaryColor}`,
      headerTopBorderColor: `${headerTopBorderColor}`,
      headerBottomBorderColor: `${headerBottomBorderColor}`,
      mainBackgroundColor: `${mainBackgroundColor}`,
      listSelectionBackgroundColor: `${listSelectionColor}`,
      footerBackGroundColor: `${footerColor}`,
      footerTextColor: `${footerTextColor}`,
      footerTopBorderColor: `${footerTopBorderColor}`,
      listItemHoverColor: `${listItemHoverColor}`,
      loadingSpinnerTopColor: `${footerTopBorderColor}`,
      loadingSpinnerBottomColor: `${primaryColor}`,
      loadingSpinnerHeaderColor: `${headerTopBorderColor}`,
    },
    links: {
      contactUsLink: `${contactUsLink}`,
      logoLink: `${logoLink}`,
      termsAndConditionsLink: `${termsAndConditions}`,
      companyInformation: `${companyInformation}`,
    },
    text: {
      footerText: `${footerText}`,
      title: `${title}`,
      description: `${description}`,
      contactNumber: `${contactNumber}`,
      noShopsFoundMessage: `${noShopsFoundMessage}`,
    },
    styles: {
      headerSpinner: {
        fontFamily: "Montserrat",
        fontWeight: 500,
        fontSize: "32px",
        color: `${headerTopBorderColor}`,
      },
      headerSecondary: {
        fontFamily: "Montserrat",
        fontWeight: 500,
        fontSize: "32px",
        color: `${headerTopBorderColor}`,
      },
      headerSub: {
        fontFamily: "Montserrat",
        fontWeight: 500,
        fontSize: "28px",
        color: `${headerTopBorderColor}`,
      },
      headerContactUs: {
        fontFamily: "Roboto",
        fontWeight: 700,
        fontSize: "16px",
        color: `${headerTopBorderColor}`,
      },
      headerTitle: {
        fontFamily: "Montserrat",
        fontWeight: 500,
        fontSize: "36px",
        color: `${headerTopBorderColor}`,
      },
      primaryDescription: {
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: "16px",
        color: `${headerTopBorderColor}`,
      },
      secondaryDescription: {
        fontFamily: "Roboto",
        fontWeight: 400,
        fontSize: "18px",
        color: `${headerTopBorderColor}`,
      },
      linkText: {
        fontFamily: "Roboto",
        fontWeight: 700,
        fontSize: "18px",
        color: `#0080A3`,
        textTransform: "capitalize",
        order: 0,
        "@media (max-width: 480px)": {
          order: 0,
          marginBottom: "13px",
        },
      },
      linkButtonText: {
        fontFamily: "Roboto",
        fontWeight: 700,
        fontSize: "18px",
        color: `#0080A3`,
        textTransform: "uppercase",
        order: 0,
        "@media (max-width: 480px)": {
          order: 0,
          marginBottom: "13px",
        },
      },
      hiddenPadding: "27px",
      rowSpan: {
        order: 1,
        flexGrow: 1,
      },
      themeType: {
        currentThemeType: ThemeType.MSA,
      },
      uploadButton: {
        height: "44px",
        textTransform: "capitalize",
      },
      submitButton: {
        order: 2,
        backgroundColor: `${primaryColor}`,
        textTransform: "uppercase",
        color: "#fff",
        fontSize: "1em",
        fontWeight: 700,
        borderRadius: `${searchButtonBorderRadius}`,
        "@media (max-width: 480px)": {
          order: 2,
          width: "100%",
          marginRight: "0px !important",
          marginLeft: "0px !important",
          marginBottom: "13px",
        },
        "&:hover": {
          backgroundColor: `${primaryColor}`,
        },
      },
      iconColor: "#0B3B60",
    },
  },
});
